import { render } from "./InterstitialPage.vue?vue&type=template&id=3729ed8e&scoped=true"
import script from "./InterstitialPage.vue?vue&type=script&lang=js"
export * from "./InterstitialPage.vue?vue&type=script&lang=js"

import "./InterstitialPage.vue?vue&type=style&index=0&id=3729ed8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3729ed8e"]])

export default __exports__